export const calcPos = (pos?: string) => {
  switch (pos) {
    case 'default-top':
      return { top: '0px', left: '0px', padding: '150px 144px 48px 205px' };
    case 'default':
      return { bottom: '0px', left: '0px', padding: '48px 144px 48px 205px' };
    case 'left-top':
      return { top: '0px', left: '0px', padding: '48px 144px 48px 64px' };
    case 'left-center':
      return {
        top: '50%',
        transform: 'translateY(-50%)',
        left: '0px',
        padding: '48px 144px 48px 64px',
      };
    case 'left-bottom':
      return { bottom: '0px', left: '0px', padding: '48px 144px 48px 64px' };
    case 'right-top':
      return {
        top: '0px',
        right: '0px',
        padding: '48px 64px 48px 144px',
        width: '480px',
      };
    case 'right-center':
      return {
        top: '50%',
        transform: 'translateY(-50%)',
        right: '0px',
        padding: '48px 64px 48px 144px',
        width: '480px',
      };
    case 'right-bottom':
      return {
        bottom: '0px',
        right: '0px',
        padding: '48px 64px 48px 144px',
        width: '480px',
      };
    default:
      return { bottom: '0px', left: '0px', padding: '48px 144px 48px 64px' };
  }
};
export const calcPos = (pos?: string) => {
  switch (pos) {
    case 'default-top':
      return { top: '0px', left: '0px', padding: '150px 144px 48px 205px' };
    case 'default':
      return { bottom: '0px', left: '0px', padding: '48px 144px 48px 205px' };
    case 'left-top':
      return { top: '0px', left: '0px', padding: '48px 144px 48px 64px' };
    case 'left-center':
      return {
        top: '50%',
        transform: 'translateY(-50%)',
        left: '0px',
        padding: '48px 144px 48px 64px',
      };
    case 'left-bottom':
      return { bottom: '0px', left: '0px', padding: '48px 144px 48px 64px' };
    case 'right-top':
      return {
        top: '0px',
        right: '0px',
        padding: '48px 64px 48px 144px',
        width: '480px',
      };
    case 'right-center':
      return {
        top: '50%',
        transform: 'translateY(-50%)',
        right: '0px',
        padding: '48px 64px 48px 144px',
        width: '480px',
      };
    case 'right-bottom':
      return {
        bottom: '0px',
        right: '0px',
        padding: '48px 64px 48px 144px',
        width: '480px',
      };
    default:
      return { bottom: '0px', left: '0px', padding: '48px 144px 48px 64px' };
  }
};
